import Vue from 'vue'
import App from './App.vue'

import router from './router/router'
import store from './store/store'
import VeLine from 'v-charts/lib/line.common'
import 'promise-polyfill/src/polyfill'
import 'whatwg-fetch'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@fortawesome/fontawesome-free/css/all.css'
// import Lodash from 'lodash'
import VueVideoPlayer from 'vue-video-player'
import DateFilter from './views/bookcoach/date';
Vue.filter('date', DateFilter)

Vue.component(VeLine.name, VeLine);

Vue.use(
  Vuetify,
  VueVideoPlayer
  // Lodash
)

new Vue({ // eslint-disable-line no-new
  el: '#app',
  store,
  router,
  render: h => h(App)
});// eslint-disable-line



// WEBPACK FOOTER //
// ./src/main.js